// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__4_p7J","bigColWidth":"Table_bigColWidth__2tLo8","biggerColWidth":"Table_biggerColWidth__1EiwC","row":"Table_row__29ZaS","col":"Table_col__2Wrcl"};